var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlandingUpArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49995 3.16895L16.7094 3.16895C16.8723 3.16895 17.0284 3.23363 17.1436 3.34877C17.2587 3.46391 17.3234 3.62008 17.3234 3.78291V12.9924C17.3234 13.3315 17.0485 13.6063 16.7094 13.6063C16.3703 13.6063 16.0955 13.3315 16.0955 12.9924V5.26515L4.86427 16.4963C4.6245 16.7361 4.23576 16.7361 3.99599 16.4963C3.75622 16.2566 3.75622 15.8678 3.99599 15.6281L15.2272 4.39687L7.49995 4.39688C7.16087 4.39688 6.88598 4.12199 6.88598 3.78291C6.88598 3.44383 7.16087 3.16895 7.49995 3.16895Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlandingUpArrow);
export default __webpack_public_path__ + "static/media/slanding-up-arrow.fbeb85cdcecfc807ea4d7836d4423bec.svg";
export { ForwardRef as ReactComponent };